import {Component, OnInit} from '@angular/core';
import {Card} from '../../../_models/card.model';
import {Observable} from 'rxjs';
import {CrisisAlertService} from '../../services/crisis-alert.service';

@Component({
  selector: 'app-dashboard-summary',
  templateUrl: './dashboard-summary.component.html',
  styleUrls: ['./dashboard-summary.component.scss']
})
export class DashboardSummaryComponent implements OnInit {
  serverTime: Observable<number>;
  cards: Observable<Card[]>;

  constructor(private crisisAlertService: CrisisAlertService) {
  }

  ngOnInit() {
    this.cards = this.crisisAlertService.cardsObs;
    this.serverTime = this.crisisAlertService.serverTimeObs;
  }

}
